import { datetime } from "../../../util/library/datetime";
import { KeyOfStep, listOfStep, SHORT_DATETIME_FORMAT } from "../../../util/varibles/constants";
import { IActivityLog } from "../../../util/varibles/interface";

interface IProps {
    data: IActivityLog
}

export default function CompleteStep({ data }: IProps) {
    return <div className='flex flex-col items-center'>
        <div className='text-comment'>{datetime(data.est_start_time).format(SHORT_DATETIME_FORMAT)}</div>
        {data.real_start_time &&
            <span>{datetime(data.real_start_time).format(SHORT_DATETIME_FORMAT)}</span>}
        <div className='text-[15px] font-[600] text-[--color1]'>{listOfStep[KeyOfStep.COMPLETED].name}</div>
    </div>
}